import { Reveal, SectionLabel } from "./Reveal";

export default function PageHero({ eyebrow, title, sub, children, image }) {
  return (
    <section className="relative border-b border-stone pt-32 lg:pt-40" data-testid="page-hero">
      <div className="mx-auto grid max-w-[1440px] gap-10 px-5 pb-16 sm:px-8 lg:grid-cols-12 lg:px-12 lg:pb-24">
        <Reveal className={image ? "lg:col-span-6" : "lg:col-span-9"}>
          {eyebrow && <SectionLabel>{eyebrow}</SectionLabel>}
          <h1 className="mt-6 font-serif text-5xl leading-[0.98] text-charcoal sm:text-6xl lg:text-7xl">{title}</h1>
          {sub && <p className="mt-6 max-w-2xl font-serif text-2xl italic leading-snug text-forest">{sub}</p>}
          {children}
        </Reveal>
        {image && (
          <Reveal className="lg:col-span-5 lg:col-start-8" delay={0.1}>
            <div className="overflow-hidden" style={{ clipPath: "polygon(8% 0, 100% 0, 100% 100%, 0 100%, 0 12%)" }}>
              <img src={image} alt="" className="aspect-[4/3] w-full object-cover" />
            </div>
          </Reveal>
        )}
      </div>
    </section>
  );
}
